import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

export const usePermissions = () => {
  const user = useSelector((state: RootState) => state.auth.user);
  
  // Convert roles to string for comparison
  const userRole = String(user?.roles);
  
  const isAdmin = userRole === '1';
  const isViewer = userRole === '2';

  // Add debug logging
  console.log('Permission checks:', { userRole, isAdmin, isViewer });

  return {
    isAdmin,
    isViewer,
    // Add specific permissions
    canManageSensors: isAdmin,
    canManageBaseUnits: isAdmin,
    canManageZones: isAdmin,
    canManageUsers: isAdmin,
    canEditSettings: isAdmin,
    // Add more permissions as needed
  };
}; 